import type { TenantGroups } from '@snowit/types/tenants';
import type { Loaders, Store } from './types';

import * as cache from '@snowit/cache';

import { ALL_LOADERS } from './types';

const defaultStore: Store = {
  loaders: ALL_LOADERS.reduce(
    (memo, load) => ({ ...memo, [load]: false }),
    {} as Record<Loaders, boolean>,
  ),
  carts: {
    list: [],
  },
  options: {
    list: [],
    ready: false,
  },
  prices: {
    list: [],
  },
  products: {
    list: [],
  },
  brevo: {
    list: [],
  },
  memberships: {
    list: [],
    filters: {},
  },
  snowitcards: {
    list: [],
  },
  tenants: {
    list: [],
    messages: [],
    active: cache.getLocal<string[]>('tenants') ?? [],
    bookmarks: cache.getLocal<string[]>('tenants_bookmarks') ?? [],
    ready: false,
    groups: cache.getLocal<TenantGroups>('tenants_groups') ?? {},
  },
  zones: {
    list: [],
    ready: false,
  },
  districts: {
    list: [],
    ready: false,
  },
  departures: {
    list: [],
    ready: false,
  },
  shipping_methods: {
    list: [],
    ready: false,
  },
  venues: {
    list: [],
    ready: false,
  },
  categories: {
    list: [],
    ready: false,
  },
  partners: {
    list: [],
    ready: false,
    selected: window.localStorage.getItem('partner') ?? undefined,
  },
  policies: {
    list: [],
    ready: false,
  },
  settings: {
    fontsize: window.localStorage.getItem('fontsize') ?? 'var(--fs-base-md)',
    theme: window.localStorage.getItem('theme') ?? 'dark',
  },
  monitoring: {
    data: {
      providers: { list: [] },
      mailers: { list: [] },
      invoice: { list: [] },
      netstorming: { list: [] },
      orders_processing: { list: [] },
      orders_sepa: { list: [] },
      orders_sync: { list: [] },
      failed_transits: { list: [] },
      membership_assignment_status: { list: [] },
      membership_blocked: { list: [] },
      membership_unpaid: { list: [] },
    },
    counters: {
      invoices: 0,
      mailers: 0,
      netstorming: 0,
      orders_processing: 0,
      orders_sepa: 0,
      orders_sync: 0,
      providers: 0,
      failed_transits: 0,
    },
    trenordCounters: {},
    retryAt: 0,
  },
  reviews: { list: [] },
  external_codes: { list: [] },
  checkout_codes: { list: [] },
  provider_orders: { list: [] },
  trenitalia_orders: { list: [] },
  dealer_orders: { list: [] },
  orders: { list: [] },
  coupons: { list: [] },
  seasons: { list: [], ready: false },
  discounts: { list: [] },
  skipass_promos: { list: [] },
  skipass_groups: { list: [] },
  stages: { list: [] },
  tags: { list: [], ready: false },
  routes: { list: [] },
  carousels: { list: [] },
  notifications: { list: [] },
  imports: {
    list: [],
    syncStatus: [],
  },
  transits: {
    list: [],
  },
  challenges: {
    list: [],
  },
  turnstiles: {
    list: [],
  },
  exportRequests: {
    list: [],
  },
  users: {
    list: [],
    selected: undefined,
  },
};

export default defaultStore;
